import { EnvironmentInterface } from '@nutt/configuration';

export const environment: Readonly<EnvironmentInterface> = {
  isProduction: false,
  apiBaseUrl: 'https://grobbee.nutt.test.m4mapp.com/api/',
  clientId: '73a444d85c7deeefedb50348b2f2d028',
  avatarBaseUrl: 'https://s3-eu-west-1.amazonaws.com/nutt-grobbee-test-jvfw9/',
};
